import { adjustmentSessionIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const findAdjustmentSessionBySource = {
  name: "findAdjustmentSessionBySource" as const,
  input: z.object({ sourceId: z.string() }),
  output: z.object({ sessionId: adjustmentSessionIdFormat.schema.nullable() }),
};
